import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice } from "@grandvisionhq/utils";
/* empty css               */
const BestPrice = ({
  bestPriceAmount,
  currencyCode,
  className,
  isCentAmount = false,
  isFeatureEnabled,
  discountedPrice,
  originalPrice
}) => {
  const { getFormattedLabel, locale } = useIntl();
  if (!isFeatureEnabled || !bestPriceAmount) {
    return null;
  }
  const shouldShowBestPrice = isFeatureEnabled && bestPriceAmount && (discountedPrice && bestPriceAmount !== discountedPrice || !discountedPrice && bestPriceAmount !== originalPrice);
  if (!shouldShowBestPrice) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { "data-t": "best-price", className: classnames("best-price", className) }, getFormattedLabel("products.recentLowestPrice", {
    labelData: {
      recentLowestPrice: formatPrice({
        locale,
        value: bestPriceAmount,
        currency: currencyCode,
        isCentAmount
      })
    }
  }));
};
export {
  BestPrice
};
//# sourceMappingURL=BestPrice.js.map
